'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BannerSubtitle = renderWithRef('BannerSubtitle', null, (t, n)=>{
    let { children: o } = t;
    return jsx(RenderComp, {
        root: "p",
        forwardedRef: n,
        classNames: [
            'swan-banner-subtitle'
        ],
        props: t,
        children: o
    });
});

export { BannerSubtitle };
